<template>
  <div class="flex flex-col md:mr-0">
    <SubHero v-if="subHero.fields" :content="subHero" />
    <div class="grid grid-cols-1 gap-3 lg:gap-4 lg:grid-cols-3">
      <PromotionTrackingWrapper v-for="(subBanner, index) in subBanners" :key="index" :content="subBanner">
        <SubBanner :content="subBanner" />
      </PromotionTrackingWrapper>
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  content?: Record<string, any>;
};

const { content } = withDefaults(defineProps<Props>(), {
  content: undefined,
});
const subHero = content?.fields?.subHero || {};
const subBanners = content?.fields?.subBanners || [];
</script>
<script lang="ts">
export default defineComponent({
  name: 'LargeSection',
});
</script>
